import { createReducer } from '@reduxjs/toolkit';
import { ActionObject } from '../StoreConstants';
import { Types } from './Actions';
import INITIAL_STATE, { UiInitialState } from './InitialState';

const openMenu = (state: UiInitialState, action: ActionObject) => ({
  ...state,
  menuState: true,
});

const closeMenu = (state: UiInitialState, action: ActionObject) => ({
  ...state,
  ...INITIAL_STATE,
});

export const UiReducer = createReducer(INITIAL_STATE, {
  [Types.OpenMenu]: openMenu,
  [Types.CloseMenu]: closeMenu,
});